"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGenerator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("./utils");
const IconGenerator = (data, variant) => // eslint-disable-next-line react/display-name
 ({ className, ...props }) => ((0, jsx_runtime_1.jsx)("svg", { ...data.attr, ...props, className: (0, utils_1.handleClassName)(variant, className ?? ""), children: (0, utils_1.tree2Element)(data.child) }));
exports.IconGenerator = IconGenerator;
